import { useId } from "react"

import { Input } from "@coval/ui/input"

import { FieldLabel } from "@/components/shared/forms/FieldLabel"

import { EmailRecipientAllowlistConfig } from "./EmailRecipientAllowlistConfig"

interface EmailSimulatorConfigProps {
  simulationMetadata: Record<string, unknown>
  onMetadataUpdate: (metadata: Record<string, unknown>) => void
}

export function EmailSimulatorConfig({
  simulationMetadata,
  onMetadataUpdate,
}: EmailSimulatorConfigProps) {
  const recipientEmailId = useId()
  const subjectId = useId()
  const recipientEmail = simulationMetadata.recipient_email
  const subject = simulationMetadata.subject

  return (
    <div className="space-y-4">
      <div className="space-y-2">
        <FieldLabel htmlFor={recipientEmailId} required>
          Recipient email
        </FieldLabel>
        <Input
          id={recipientEmailId}
          data-testid="email-recipient-input"
          type="email"
          value={typeof recipientEmail === "string" ? recipientEmail : ""}
          onChange={(event) =>
            onMetadataUpdate({ recipient_email: event.target.value })
          }
          placeholder="agent@example.com"
        />
      </div>
      <div className="space-y-2">
        <FieldLabel htmlFor={subjectId} required>
          Subject
        </FieldLabel>
        <Input
          id={subjectId}
          data-testid="email-subject-input"
          value={typeof subject === "string" ? subject : ""}
          onChange={(event) =>
            onMetadataUpdate({ subject: event.target.value })
          }
          maxLength={255}
          placeholder="Simulation conversation"
        />
      </div>
      <EmailRecipientAllowlistConfig />
    </div>
  )
}
